import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceTypeAppResource from "./WorkspaceTypeAppResource";
import KnowledgeAssetArticleAppResource from "./KnowledgeAssetArticleAppResource";
import KnowledgeAssetVideoAppResource from "./KnowledgeAssetVideoAppResource";

class KnowledgeAssetCategoryAppResource extends AppResource {
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'knowledge-asset-category';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'knowledge/assets/categories';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'hubTypeUuid',
            'hubType',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            hubType: WorkspaceTypeAppResource,
            articles: KnowledgeAssetArticleAppResource,
            videos: KnowledgeAssetVideoAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            hubType: 'hub_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
            },
            hubTypeUuid: {
                type: 'string',
                presence: true,
            },
        };
    }
}

export default KnowledgeAssetCategoryAppResource;
